import { render, staticRenderFns } from "./CompaniesCRM.vue?vue&type=template&id=a235052c&scoped=true"
import script from "./CompaniesCRM.vue?vue&type=script&lang=js"
export * from "./CompaniesCRM.vue?vue&type=script&lang=js"
import style0 from "./companies-crm.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./CompaniesCRM.vue?vue&type=style&index=1&id=a235052c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a235052c",
  null
  
)

export default component.exports